<div class="header_hero-bg">
  <div class="header_hero-bg__progress-bar fm-progress-bar--center">
    <invd-fm-progress-bar
      class="fm-progress-bar fm-progress-bar--medium"
      [steps]="steps"
      [currentStep]="currentStep"
      [ignoreRoute]="ignoreRoute"
    >
    </invd-fm-progress-bar>
  </div>
</div>

<div class="mega-trade-container container-fluid">
  <router-outlet></router-outlet>
</div>
